import classNames from "classnames";
import React, { FC } from "react";
import { LuInfo } from "react-icons/lu";
import { Navigate, NavLink, Route, Routes } from "react-router-dom";

import { useTabCounts } from "./board/useWorksBoard";
import { WORKS_TABS } from "./board/worksBoard.utils";
import { WorksBoardPage } from "./board/WorksBoardPage";

const InfoTip: FC<{ text: string }> = ({ text }) => (
  <span className={"group relative inline-flex"}>
    <LuInfo size={14} strokeWidth={2} className={"text-[#A3A9B8]"} />
    <span
      className={
        "pointer-events-none absolute left-1/2 top-full z-40 mt-2 hidden w-[260px] -translate-x-1/2 whitespace-normal rounded-lg bg-[#1F2433] px-3 py-2 text-left text-[12px] font-medium leading-[1.45] text-white shadow-lg group-hover:block"
      }>
      {text}
    </span>
  </span>
);

export const WorksView = () => {
  const counts = useTabCounts();

  return (
    <div className={"w-full pb-10 pl-[1px]"}>
      <h1
        className={
          "text-[26px] font-extrabold tracking-[-0.4px] text-[#1F2433]"
        }>
        Work
      </h1>
      <div
        className={
          "mb-6 mt-4 flex flex-wrap items-center gap-7 border-b border-[#E8E8EC] max-md:gap-x-5 max-md:gap-y-1"
        }>
        {WORKS_TABS.map((tab) => (
          <div key={tab.key} className={"flex items-center gap-1.5"}>
            <NavLink
              to={tab.path}
              className={({ isActive }) =>
                classNames(
                  "-mb-px flex items-center gap-2 border-b-[2.5px] pb-3 pt-1 text-[14.5px] font-bold",
                  isActive
                    ? "border-[#6B4EFF] text-[#6B4EFF]"
                    : "border-transparent text-[#6F7688] hover:text-[#3A4256]",
                )
              }>
              {tab.label}
              {counts[tab.key] !== undefined && (
                <span
                  className={
                    "rounded-full bg-[#F0EDFF] px-2 py-[1px] text-[11.5px] font-extrabold text-[#5B3DF5]"
                  }>
                  {counts[tab.key]}
                </span>
              )}
            </NavLink>
            <span className={"pb-3 pt-1"}>
              <InfoTip text={tab.tip} />
            </span>
          </div>
        ))}
      </div>
      <Routes>
        <Route index element={<Navigate to={"./all"} replace={true} />} />
        <Route
          path={"all"}
          element={<WorksBoardPage key={"active"} tab={"active"} />}
        />
        <Route path={"my"} element={<WorksBoardPage key={"my"} tab={"my"} />} />
        <Route
          path={"queued"}
          element={<WorksBoardPage key={"queued"} tab={"queued"} />}
        />
        <Route
          path={"completed"}
          element={<WorksBoardPage key={"completed"} tab={"completed"} />}
        />
        <Route
          path={"archived"}
          element={<WorksBoardPage key={"archived"} tab={"archived"} />}
        />
        <Route path={"*"} element={<>Not found</>} />
      </Routes>
    </div>
  );
};
